import { getInitialState } from './initialState';

const initialState = getInitialState(typeof window === 'undefined');

const deathPrayersReducer = (state = initialState) => {
  return state;
};

export default deathPrayersReducer;
